import { createContext } from 'react';

export const AriaAlertContext = createContext<{
  setAriaAlertMessage: Function;
} | null>({
  setAriaAlertMessage: null,
});
